import Input from '@/components/atoms/Input';
import { cn } from '@/utils/tailwind';
import { useChatbotContext } from '../../_context/ChatbotContext';
import { useChatbotActions } from '@/hooks/V3/useChatbotActions';

import { useRecoilState } from 'recoil';
import { isMobileState } from '@/store/atom';
import { useChatHandleKeyDown } from '@/hooks/V3/useChatHandleKeyDown';

interface AiChatbotInputProps {
  inputRef: React.RefObject<HTMLTextAreaElement>;
  rows?: number;
  isDashboard?: boolean;
}

const AiChatbotInput = ({ inputRef, rows, isDashboard = false }: AiChatbotInputProps) => {
  const { input, setInput, isLoading, isThinking } = useChatbotContext();
  const { handleSendMessage } = useChatbotActions('keyboard_input');
  const isActive = !isLoading && !isThinking && input.trim();
  const [isMobile] = useRecoilState(isMobileState);

  const { handleKeyDown, handleCompositionStart, handleCompositionEnd } = useChatHandleKeyDown({
    sendMessage: () => {
      if (isActive) handleSendMessage(input); // `isActive` 확인 후 실행
    },
    isMobile,
  });

  const handleInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInput(e.target.value.replace(/ {2,}/g, ' '));
  };

  return (
    <div
      className={cn('flex py-[10px]', {
        ' pl-[16px] pr-[12px]': !isDashboard,
      })}
    >
      <Input
        textarea
        rows={rows}
        ref={inputRef}
        className={cn(
          'resize-none overflow-y-auto rounded-[8px] border-none py-[10px] pr-[70px] Body5M14 scrollbar-hide focus:border-none',
          isDashboard ? 'bg-gr-50 ' : 'bg-gr-100',
        )}
        value={input}
        onChange={handleInput}
        onKeyDown={handleKeyDown}
        onCompositionStart={handleCompositionStart}
        onCompositionEnd={handleCompositionEnd}
        placeholder="궁금한 데이터를 입력하세요"
        InputProps={{
          endAdornment: (
            <button
              disabled={!isActive} // 비활성화 상태 적용
              onClick={() => handleSendMessage(input)}
              className={cn(
                'w-[48px] rounded-[8px] px-[8px] py-[5px] text-white Caption1M12',
                isActive ? (isDashboard ? 'bg-point-500' : 'bg-point-500') : 'bg-gr-300',
              )}
            >
              전송
              {/* 만들기 */}
            </button>
          ),
          endAdornmentStyle: 'right-[8px] absolute m-auto whitespace-nowrap bottom-[7px]',
        }}
        maxLength={100}
      />
    </div>
  );
};

export default AiChatbotInput;
